import { OrgTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const loadColorPalettes = createAction('[ColorPalette] Load ColorPalettes', props<{ username: string }>());

export const loadColorPalettesSuccess = createAction(
  '[ColorPalette] Load ColorPalettes Success',
  props<{ palettes: OrgTypes.ColorPalette[] }>()
);

export const loadColorPalettesFailure = createAction(
  '[ColorPalette] Load ColorPalettes Failure',
  props<{ error: any }>()
);
